import { render, staticRenderFns } from "./EditNotes.vue?vue&type=template&id=cc54fbe4&scoped=true"
import script from "./EditNotes.vue?vue&type=script&lang=js"
export * from "./EditNotes.vue?vue&type=script&lang=js"
import style0 from "./EditNotes.vue?vue&type=style&index=0&id=cc54fbe4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc54fbe4",
  null
  
)

export default component.exports